import React from 'react';
import ReactTable from '../components/ReactTable';
import { usePositionHistoryCols } from '../hooks/EmployeeCols';

export default function PositionHistory(props) {
    const positionHistoryCols = usePositionHistoryCols();
    if (!props.data) return null;
    return <ReactTable cols={positionHistoryCols} data={props.data} />;
}
